export default "/_next/static/chunks/fonts/Quicksand-Medium-latin-eeb068c5746aa56faf46bb7c3991c15a.woff2";